import actionCreatorFactory from 'typescript-fsa';
import { Dispatch, Action } from 'redux';
import { getAPI } from '../utils/APIUtils';

import { WhatsnewAct } from '../states/whatsnewState';
import { appActions } from './appAction';

const actionCreator = actionCreatorFactory();

export const whatsnewAction = {
  getWhatsnew: actionCreator<WhatsnewAct[]>('ACTIONS_GET_WHATSNEW'),
  getWhatsnewAsync: (accountId: string, id: string, isInit: boolean = false) => {
    return async (dispatch: Dispatch<Action>) => {
      try {
        const url = `/publication?accountid=${accountId}&id=${id}`;
        const json = await getAPI(url);
        dispatch(whatsnewAction.getWhatsnew(json));

      } catch (err) {
        console.log(err);
      };

      if (!isInit) {
        dispatch(appActions.setLoading(false));
      }
    };
  },

};